<script lang="ts" setup>
import LabelTag from "~/components/form/LabelTag.vue";
import InputTag from "~/components/form/InputTag.vue";
import ButtonPrimary from "~/components/ButtonPrimary.vue";
import axios from "axios";

definePageMeta({
    middleware: "guest",
});

// Data
const config = useRuntimeConfig();
const form = ref({
    email: "",
    token: "",
});
const msg = ref("");

// Functions
async function requestPassword() {
    try {
        const { data: response } = await axios.post(config.public.STATAMIC_API + "/forgot-password", form.value);

        if (!response.status) {
            msg.value = '<div class="text-abc-red"> ' + response.message + "</div>";
        } else {
            msg.value = '<div class=""> ' + response.message + "</div>";
        }
    } catch (e: any) {
        console.log(e);
    }
}
</script>

<template>
    <div>
        <H1Heading class="mb-8 text-center">Forgot Password</H1Heading>

        <form class="mx-auto md:w-96" @submit.prevent="requestPassword">
            <div class="mt-4">
                <LabelTag for="email">
                    We will send you a message with instructions on how to reset your password.
                </LabelTag>
                <InputTag
                    id="email"
                    v-model="form.email"
                    type="email"
                    class="mt-2 w-full"
                    placeholder="Enter email"
                    required
                />
            </div>

            <NuxtTurnstile v-model="form.token" data-theme="light" class="mt-4 mb-6" />

            <div class="mb-6 text-center" v-html="msg"></div>

            <div class="text-center">
                <ButtonPrimary type="submit" class="w-full md:w-1/2">OK</ButtonPrimary>
            </div>
        </form>
    </div>
</template>

<style scoped></style>
